module.exports = __webpack_public_path__ + "static/basics-7feb7282701e5a7db74b5fc94477afd5.png";